module.exports = __webpack_public_path__ + "img/grade3.488e3649.jpg";